import { UserProfileProps } from "../../api/auth/login";

const AUTH_STORAGE_KEY = "web_auth_data";
const CAPACITOR_AUTH_TOKEN = "web_auth_token";
/**
 * Save authentication data to localStorage.
 * @param data - The authentication data to store.
 */
export const setAuthData = (data: UserProfileProps): Promise<void> => {
  return new Promise((resolve) => {
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(data));
    resolve();
  });
};

/**
 * Retrieve authentication data from localStorage.
 * @returns The authentication data or null if not found.
 */
export const getAuthData = (): UserProfileProps | null => {
  const data = localStorage.getItem(AUTH_STORAGE_KEY);
  if (data) {
    return JSON.parse(data) as UserProfileProps;
  }
  return null;
};

/**
 * Clear authentication data from localStorage.
 */
export const clearAuthData = (): void => {
  localStorage.removeItem(AUTH_STORAGE_KEY);
};

export const storeTokenOnMobile = (token: string): void => {
  localStorage.setItem(CAPACITOR_AUTH_TOKEN, JSON.stringify(token));
};

export const getCapacitorAuthToken = (): string | null => {
  const data = localStorage.getItem(CAPACITOR_AUTH_TOKEN);
  if (data) {
    return JSON.parse(data) as string;
  }
  return null;
};
